type ModalHeaderProps = {
    className?: string;
    title: string | React.ReactNode;
    subtitle?: string;
};

const ModalHeader = ({ className, title, subtitle }: ModalHeaderProps) => {
    return (
        <div className={`mb-10 max-md:mb-8 ${className || ""}`}>
            {
                typeof title === 'string' ? (
                    <div className="text-h4 text-center max-md:text-h5">
                        {title}
                    </div>
                ) : title
            }
            {subtitle && (
                <div className="mt-2 text-center text-caption text-t-tertiary">
                    {subtitle}
                </div>
            )}
        </div>
    );
};

export default ModalHeader;
